// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2X-r2","container":"styles_container__BPKc3","title":"styles_title__3O9bq","wrapper":"styles_wrapper__dJav4","answer":"styles_answer__aDPZ5"};